class ShippingProtection extends HTMLElement {
	constructor() {
		super();
		this.itemName = `shippingProtection_${Shopify.shop}`;
		this.insuranceProduct = JSON.parse(
			this.querySelector('[type="application/json"]').textContent
		);

		this.cartUpdated = this.onCartUpdate.bind(this);

		this.insuranceId = this.insuranceProduct.id;
		this.insuranceVariantId = this.insuranceProduct.variants[0].id;
		this.itemSelector = `.cart-item[data-product-id="${this.insuranceId}"]`;

		this.cart =
			document.querySelector("cart-notification") ||
			document.querySelector("cart-drawer");

		this.checkbox = this.querySelector('input[type="checkbox"]');
		this.checkbox.addEventListener(
			"change",
			this.checkboxHandler.bind(this)
		);
	}

	connectedCallback() {
		const itemValue = localStorage.getItem(this.itemName) || "true";

		const valueToBool = itemValue === "true";
		this.updateState(valueToBool);

		this.changeListener = document.addEventListener("cart:change", this.cartUpdated);
	}

	// disconnectedCallback() {
	// 	document.removeEventListener("cart:change", this.cartUpdated);
	// }

	updateItem(id, quantity) {
		const formData = {
			id: `${id}`,
			quantity,
		};

		return fetch(`${Shopify.routes.root}cart/change.js`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(formData),
		})
			.then((response) => {
				this.renderCart();
			})
			.catch((error) => {
				console.error("Error:", error);
			});
	}

	addItemById(id, quantity) {
		const formData = {
			items: [
				{
					id: id,
					quantity: quantity,
				},
			],
		};

		const config = {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Accept: `application/javascript`,
				"X-Requested-With": "XMLHttpRequest",
			},
		};

		config.body = JSON.stringify(formData);

		fetch(`${Shopify.routes.root}cart/add.js`, config)
			.then((response) => response.json())
			.then((response) => {
				if (response.status) {
					this.handleErrorMessage(response.description);
					this.error = true;
					return;
				} else if (!this.cart) {
					window.location = window.routes.cart_url;
					return;
				}

				if (!this.error) this.renderCart();
				this.error = false;
			})
			.catch((e) => {
				console.error(e);
			})
			.finally(() => {});
	}

	async renderCart() {
		document.documentElement.dispatchEvent(
			new CustomEvent("cart:refresh", {
				bubbles: true,
				detail: {},
			})
		);
	}

	onCartUpdate(event) {
		const isEnabled = localStorage.getItem(this.itemName) === "true";
		if (isEnabled) {
			const itemCount = event.detail.cart["item_count"];
			const hasInsurance = event.detail.cart.items.some(
				(item) => item.product_id === this.insuranceId
			);
			if (itemCount >= 1 && !hasInsurance) {
				this.addInsurance(false);
			} else if (itemCount === 1 && hasInsurance) {
				this.removeInsurance(false);
			}
		}
	}

	checkboxHandler() {
		this.checkbox.checked ? this.addInsurance() : this.removeInsurance();
	}

	updateState(state) {
		this.checkbox.checked = state;
		this.enabled = state;
		localStorage.setItem(this.itemName, state);
	}

	addInsurance(updateState = true) {
		if (updateState) {
			this.updateState(true);
		}
		this.addItemById(this.insuranceVariantId, 1);
	}

	removeInsurance(updateState = true) {
		if (updateState) {
			this.updateState(false);
		}
		this.updateItem(this.insuranceVariantId, 0);
	}

	setInsurancePrice() {
		const currentInsurance =
			document.querySelector(this.itemSelector)?.dataset.productPrice ||
			0;
		const cartTotal =
			document.querySelector("[data-cart-total]").dataset.cartTotal;
		const primceAim =
			(cartTotal - currentInsurance) * (this.dataset.percentage / 100);

		this.querySelector("span[data-price]").textContent = Math.round(
			primceAim / 100
		);
	}
}
customElements.define("shipping-protection", ShippingProtection);

class RemoveInsurance extends HTMLElement {
	constructor() {
		super();
		this.addEventListener("click", this.removeInsurance.bind(this));
	}

	removeInsurance(e) {
		e.preventDefault();
		document.querySelector("shipping-protection").removeInsurance();
	}
}

customElements.define("remove-insurance", RemoveInsurance);
